import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";
import { SaasConnectionUrlDomain } from "../../../../dashboard/saas/types";

const VERSION = 3;
const URL = API_URL + "/saas/multi-tenancy/connection-uri-domain/list";

export async function getMultiTenantApps({
    cancelURL,
    successURL
}: {
    cancelURL: string;
    successURL: string;
}): Promise<SaasConnectionUrlDomain[]> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params: {
            cancelURL,
            successURL
        }
    };

    const result = await httpNetworking.simpleGETRequest(URL, options, VERSION);
    return result.data as SaasConnectionUrlDomain[];
}
